'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Panel = require('./Panel');

Object.defineProperty(exports, 'Panel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Panel).default;
  }
});

var _PanelContent = require('./PanelContent');

Object.defineProperty(exports, 'PanelContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PanelContent).default;
  }
});

var _PanelTitle = require('./PanelTitle');

Object.defineProperty(exports, 'PanelTitle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PanelTitle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/panel/index.js
// module id = 592
// module chunks = 0